// ACF BLOCKS
// ===================================================

var blocks = {

    settings: {
        overlapped_carousel_card_slider: $('.block-carousel-card-overlapped .swiper'),
        image_carousel: $('.block-image-carousel .swiper'),
        package_slider: $('.block-packages .swiper'),
        real_estate_slider: $('.block-real-estate-slider .swiper'),
        scroll_to_target_link: $('a[href^="#"]'),
        tabbed_content: $('.block-tabbed-content'),
    },

    init: function () {
        if (this.settings.overlapped_carousel_card_slider.length) {
            this.overlappedCarouselCardSlider();
        }
        if (this.settings.image_carousel.length) {
            this.imageCarousel();
        }
        if (this.settings.package_slider.length) {
            this.packageSlider();
        }
        if (this.settings.real_estate_slider.length) {
            this.realEstateSlider();
        }
        if (this.settings.tabbed_content.length) {
            this.tabbedContent();
        }

        this.settings.scroll_to_target_link.on('click', blocks.scrollToTarget);
    },

    overlappedCarouselCardSlider: function () {
        blocks.settings.overlapped_carousel_card_slider.each(function () {

            var block = $(this).closest('.block-carousel-card-overlapped');

            var swiper = new Swiper($(this)[0], {
                loop: true,
                navigation: {
                    nextEl: block.find('.swiper-arrow.next')[0],
                    prevEl: block.find('.swiper-arrow.prev')[0],
                },
                slidesPerView: 1,
            });

        });
    },

    imageCarousel: function () {
        blocks.settings.image_carousel.each(function () {

            var block = $(this).closest('.block-image-carousel');

            var swiper = new Swiper($(this)[0], {
                loop: true,
                navigation: {
                    nextEl: block.find('.swiper-arrow.next')[0],
                    prevEl: block.find('.swiper-arrow.prev')[0],
                },
                slidesPerView: 1,
            });

        });
    },

    packageSlider: function() {

        // Slider initialization
        blocks.settings.package_slider.each(function () {

            var block = $(this).closest('.block-packages');

            var swiper = new Swiper($(this)[0], {
                loop: false,
                navigation: {
                    nextEl: block.find('.swiper-arrow.next')[0],
                    prevEl: block.find('.swiper-arrow.prev')[0],
                },
                slidesPerView: 1,
                spaceBetween: 10,
                breakpoints: {
                    640: {
                        slidesPerView: 2,
                        spaceBetween: 20,
                    },
                    960: {
                        slidesPerView: 3,
                        spaceBetween: 20,
                    },
                    1280: {
                        slidesPerView: 4,
                        spaceBetween: 30,
                    },
                },
            });

        });

        // Toggle additional info
        var packages = blocks.settings.package_slider.find('.package');

        packages.on('click', function() {
            $(this).toggleClass('active');
        });

    },

    realEstateSlider: function () {
        blocks.settings.real_estate_slider.each(function () {

            var block = $(this).closest('.block-real-estate-slider');

            var swiper = new Swiper($(this)[0], {
                centeredSlides: true,
                loop: true,
                slidesPerView: 1.3,
                spaceBetween: 10,
                breakpoints: {
                    640: {
                        centeredSlides: false,
                        loop: false,
                        navigation: {
                            nextEl: block.find('.swiper-arrow.next')[0],
                            prevEl: block.find('.swiper-arrow.prev')[0],
                        },
                        slidesPerView: 2,
                        spaceBetween: 10,
                    },
                    750: {
                        centeredSlides: false,
                        loop: false,
                        navigation: {
                            nextEl: block.find('.swiper-arrow.next')[0],
                            prevEl: block.find('.swiper-arrow.prev')[0],
                        },
                        slidesPerView: 3,
                        spaceBetween: 10,
                    },
                    1280: {
                        centeredSlides: false,
                        loop: false,
                        navigation: {
                            nextEl: block.find('.swiper-arrow.next')[0],
                            prevEl: block.find('.swiper-arrow.prev')[0],
                        },
                        slidesPerView: 4,
                        spaceBetween: 10,
                    },
                    1370: {
                        centeredSlides: false,
                        loop: false,
                        navigation: {
                            nextEl: block.find('.swiper-arrow.next')[0],
                            prevEl: block.find('.swiper-arrow.prev')[0],
                        },
                        slidesPerView: 4,
                        spaceBetween: 30,
                    },
                },
            });

        });
    },

    scrollToTarget: function(e) {
        var targetValue = $(this).attr('href').replace('#', '');
        if (targetValue != 'popupForm') {
            var target = $('#'+targetValue+', [name="' + targetValue + '"]');
            if (!target.length) { return; }
            var offset = $(target).offset().top;
            $('html, body').animate({
                scrollTop: offset
            }, 1000);
        }
        return false;
    },

    tabbedContent: function() {

        var tabs = blocks.settings.tabbed_content.find('.tab');
        var content = blocks.settings.tabbed_content.find('.tab-content');

        tabs.on('click', function() {
            tabs.removeClass('active');
            $(this).addClass('active');
            content.removeClass('active');
            content.eq($(this).index()).addClass('active');
        });

    },

};
blocks.init();